export default __webpack_public_path__ + "static/media/Epic War Trailer.e22034b2.mp3";